import Api from "../utils/Api";
import { createParams } from "../utils/ProgUtil";

const adminParams = (getState) => createParams(getState().login, {});

export const getPenpalOverview = () => {
  return (dispatch, getState) => {
    return Api.get(`/admin/penpal_overview?${adminParams(getState)}`);
  };
};

export const blockPenpalMember = (memberId, reason) => {
  return (dispatch, getState) => {
    return Api.post(`/admin/penpal_block_member?${adminParams(getState)}`, {
      memberId,
      reason,
    });
  };
};

export const unblockPenpalMember = (memberId) => {
  return (dispatch, getState) => {
    return Api.post(`/admin/penpal_unblock_member?${adminParams(getState)}`, {
      memberId,
    });
  };
};

export const resolvePenpalReport = (reportId, resolutionAction) => {
  return (dispatch, getState) => {
    return Api.post(`/admin/penpal_resolve_report?${adminParams(getState)}`, {
      reportId,
      resolutionAction,
    });
  };
};
